<template>
  <!-- new list -->
  <div class="nrbf">
    <ul class="nlist-box">
      <li style="float:left;margin:10px 0;border-bottom:1px dashed #888888" v-for="news of page.data" :key="news.id">
        <div class="date-time"><strong style="font-size:30px;">{{ news.day }}</strong> <br>
          {{ news.date }}
        </div>
        <div class="xinwennr">
<!--          <router-link class="Themetxthover"
                       :to="news.url"
                       style="font-size:16px;line-height:36px; font-weight:bold">
            {{ news.title }}
          </router-link>-->

          <router-link :to="news.url">
            {{ news.title }}
          </router-link>
          <p>{{ news.desc }}</p>
        </div>
        <div style="clear: both;"></div>
      </li>

    </ul>
<!--    <div class="pagebar">
      <div class="pagination">
        <router-link class="page-item page-link hidden-sm" to="/home" title="首页">首页</router-link>
        <a class="page-item page-link st" href="" title="上一页"><<</a>
        <a>1/1</a>
        <a class="page-item page-link st" href="" title="下一页">>></a>
        <a class="page-item page-link hidden-sm" href="" title="尾页">尾页</a>
      </div>
    </div>-->
  </div>
</template>

<script>
import * as newApi from "@/components/oh/newsApi";

export default {
  name: 'NewsList',
  components: {
  },
  data() {
    return {
      page: {
        totalPages: 0,
        startPage: 1,
        endPage: 1,
        leftBoundary: 0,
        rightBoundary: 0,
        pageSize: 15,
        pages: 0,
        data: []
      }
    }
  },
  props: {},
  created() {
    let queryParam = this.$route.query
    console.log('newsList queryParam', queryParam)
    let nId = 1
    if(queryParam.nId){
      nId = queryParam.nId
    }

    if(!queryParam.pageNo){
      this.page.startPage = 1
    }else{
      this.page.startPage = queryParam.pageNo
    }
    this.page = newApi.getNewsDetailPage(this.page.startPage,this.page.pageSize,nId)
    console.log('newsList page', this.page)
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
